<template>
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24" cy="24" r="24" fill="black" fill-opacity="0.9" />
    <path d="M35 24L18.5 33.5263L18.5 14.4737L35 24Z" fill="white" />
  </svg>
</template>
